export enum InputPortTypes{
    Input = "Input", 
    ColorPicker = "ColorPicker", 
    Dropdown = "Dropdown", 
    FilePicker= "Filepicker",
    Slider = "Slider"
}  





// WEBPACK FOOTER //
// C:/Users/Akshata/Documents/GitHub/mobius-dev/src/app/base-classes/port/InputPortTypes.ts